<template>
	<Layout pageTitle="Configuraciones">
		<template #cta>
			<!-- <div @click="save" class="btn btn-success">Crear</div> -->
		</template>

		<div class="container main-container">
			<div class="row row-xs">
				<div class="col col-3">
					<div class="list-group mt-2">
						<router-link
							tag="a"
							:to="`/settings`"
							:class="{ active: !tab || tab == '' }"
							class="list-group-item list-group-item-action"
							>General</router-link
						>
						<router-link
							tag="a"
							:to="`/settings/locations`"
							:class="{ active: tab == 'locations' }"
							class="list-group-item list-group-item-action"
							>Mis ubicaciones</router-link
						>
						<router-link
							tag="a"
							:to="`/settings/bank-accounts`"
							:class="{ active: tab == 'bank-accounts' }"
							class="list-group-item list-group-item-action"
							>Cuentas bancarias</router-link
						>

						<router-link
							tag="a"
							:to="`/settings/validators`"
							:class="{ active: tab == 'validators' }"
							class="list-group-item list-group-item-action"
							>Validadores</router-link
						>

						<!-- <router-link
							tag="a"
							:to="`/settings/users`"
							:class="{ active: tab == 'users' }"
							class="list-group-item list-group-item-action"
							>Usuarios</router-link
						> -->
					</div>
				</div>
				<div class="col col-9">
					<div class="card mt-2">
						<div class="card-body">
							<div v-if="!tab">
								<div class="mt-1">
									<div class="h5">General</div>
									<div class="">
										<AccountForm />
									</div>
								</div>
							</div>

							<div v-if="tab == 'locations'">
								<div class="mt-1">
									<div class="h5">Mis ubicaciones</div>
									<div class="">
										<Locations />
									</div>
								</div>
							</div>

							<div v-if="tab == 'bank-accounts'">
								<div class="mt-1">
									<div class="h5">Cuentas bancarias</div>
									<div class="">
										<BankAccounts />
									</div>
								</div>
							</div>

							<!-- <div v-if="tab == 'users'">
								<div class="mt-1">
									<div class="h5">Usuarios</div>
									<div class="">
										<Users />
									</div>
								</div>
							</div> -->

							<div v-if="tab == 'validators'">
								<div class="mt-1">
									<div class="h5">Validadores</div>
									<div class="">
										<Validators />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import AccountForm from "@/views/account/AccountForm"
import BankAccounts from "@/views/settings/BankAccounts"
import Locations from "./Locations"
// import Users from "./Users"
import Validators from "./Validators"

export default {
	name: "Settings",
	components: {
		AccountForm,
		BankAccounts,
		Locations,
		// Users,
		Validators
	},
	data() {
		return {
			tab: null
		}
	},
	beforeMount() {
		if (this.$route.params.detail) {
			this.tab = this.$route.params.detail
		}
	}
}
</script>

<style scoped>
.list-group-item.active {
	z-index: 2;
	color: #007bff;
	background-color: transparent;
	border-color: inherit;
}
</style>
